import { graphql } from '@/gql';
import type { TransactionsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchTransactions = async ({
  userId,
  phoneNumber,
  partnerCodeName,
  category,
  description,
  status,
  startDate,
  endDate,
  pagination,
}: TransactionsQueryVariables) => {
  const response = await queryExecute({
    variables: {
      userId,
      phoneNumber,
      partnerCodeName,
      category,
      status,
      description,
      startDate,
      endDate,
      pagination,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query Transactions(
        $phoneNumber: String
        $partnerCodeName: String
        $userId: String
        $status: String
        $category: Float
        $description: String
        $startDate: String
        $endDate: String
        $pagination: PaginationInputType
      ) {
        transactions(
          phoneNumber: $phoneNumber
          partnerCodeName: $partnerCodeName
          userId: $userId
          status: $status
          category: $category
          description: $description
          startDate: $startDate
          endDate: $endDate
          pagination: $pagination
        ) {
          count
          rows {
            id
            date
            category
            description
            notes
            currency
            amount
            associatedObjectType
            associatedObjectId
            createdAt
            updatedAt
            status
            errorCode
            ipAddress
            ipCountry
            device
            operatingSystem
            browser
            user {
              firstName
              lastName
              role
            }
            distributions {
              transactionId
              sortOrder
              class
              account
              amount
              associatedObjectType
              associatedObjectId
              stripeCustomerId
              stripeChargeId
              stripeRefundId
              createdAt
              status
            }
          }
          total {
            amount
            customerCredits
            customerCharge
            partnerCredits
            partnerCharge
            expiringCredits
          }
        }
      }
    `),
  });

  return response.data.transactions;
};
